var editors = [];

var scrolltotop = (id) => {
    if (id) {
        let element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({behavior: 'smooth', block: "start"});
        } else {
            console.warn("Element with id '" + id + "' not found.");
        }
    } else {
        document.getElementById('main').scrollIntoView({behavior: 'smooth', block: "start"});
    }

};

var editor = (elm) => {
    let textarea = document.getElementById(elm);

    let editor = Jodit.make(textarea, {
        "useSearch": false,
        "language": "en",
        "enter": "BR",
        "defaultMode": "1",
        "toolbarAdaptive": false,
        "askBeforePasteHTML": false,
        "askBeforePasteFromWord": false,
        "defaultActionOnPaste": "insert_only_text",
        "buttons": "bold,italic,underline,strikethrough,eraser,ul,ol,superscript,subscript,link,left,undo,redo,source",
        "buttonsMD": ""
    });

    editors.push({elm: textarea.id, editor: editor});

};

var editorremove = () => {
    if (editors && editors.length > 0) {
        for (let i = 0; i < editors.length; i++) {
            editors[i].editor.destruct();
            console.log("destroy all: ", editors[i].elm);
        }
    }
    editors = [];

}

var wysiwyg = () => {
    if (editors && editors.length > 0) {
        for (let i = 0; i < editors.length; i++) {
            let textarea = document.getElementById(editors[i]);
            if (!textarea) continue;

            let editor = Jodit.make(textarea, {
                "useSearch": false,
                "language": "en",
                "enter": "BR",
                "defaultMode": "1",
                "toolbarAdaptive": false,
                "askBeforePasteHTML": false,
                "askBeforePasteFromWord": false,
                "defaultActionOnPaste": "insert_only_text",
                "buttons": "bold,italic,underline,strikethrough,eraser,ul,ol,superscript,subscript,link,left,undo,redo,source",
                "buttonsMD": ""
            });
        }
    }
    editors = [];
}

var videoreload = (id) => {
    let video = document.getElementById(id);
    if (video) {
        video.pause();
        video.load();
    }
}

// Ctrl/Cmd+S saves the article that is open. One listener for the page, pointing at whichever
// form registered last: every opened article registers, and adding a listener each time made one
// keypress save once per article opened so far (and, with forms opening in place, call forms
// that no longer exist).
var _ctrlSComponent = null;

function registerCtrlS(component) {
    _ctrlSComponent = component;
    if (window._ctrlSBound) return;
    window._ctrlSBound = true;

    window.addEventListener('keydown', e => {
        const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
        if (!((isMac && e.metaKey && e.key === 's') || (!isMac && e.ctrlKey && e.key === 's'))) return;
        if (!_ctrlSComponent) return;

        e.preventDefault();

        // Unfocus any active form field
        if (document.activeElement && typeof document.activeElement.blur === 'function') {
            document.activeElement.blur();
        }

        _ctrlSComponent.invokeMethodAsync('TriggerSaveFromJs').catch(() => { _ctrlSComponent = null; });
    });
}

// Component reference used by copyAnalyticsLink to notify .NET after copying.
var _shareComponent = null;
function registerShare(component) {
    _shareComponent = component;
}

// Copies the analytics share link to the clipboard.
// The clipboard write is kicked off synchronously inside the click gesture:
// Safari on Mac only grants clipboard access during an active user activation,
// which is lost across a Blazor Server SignalR round-trip. So this is wired via
// a native onclick (not @onclick / JS interop). The follow-up server work
// (persist code + toast) is done afterwards via a .NET callback, which does not
// need the gesture.
var copyAnalyticsLink = () => {
    let input = document.getElementById('analytics-share-code');
    if (!input) return;

    let url = 'https://digitalmagazine.brndpl.se/analytics/' + input.value;

    let copy = (navigator.clipboard && navigator.clipboard.writeText)
        ? navigator.clipboard.writeText(url).catch(() => fallbackCopy(url))
        : Promise.resolve(fallbackCopy(url));

    copy.finally(() => {
        if (_shareComponent) {
            _shareComponent.invokeMethodAsync('OnShareCompleted');
        }
    });
};

function fallbackCopy(text) {
    let ta = document.createElement('textarea');
    ta.value = text;
    ta.style.position = 'fixed';
    ta.style.top = '0';
    ta.style.left = '0';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    try { document.execCommand('copy'); } catch (e) { /* ignore */ }
    document.body.removeChild(ta);
}

// Scrolls a part of the spine into view and points at it with a small arrow, for the jump
// buttons of the shared statistics. A section gets the arrow at its heading, a row beside it.
function spineJump(id) {
    let el = document.getElementById(id);
    if (!el) return;

    el.scrollIntoView({behavior: 'smooth', block: el.tagName === 'SECTION' ? 'start' : 'center'});

    let mark = el.tagName === 'SECTION' ? (el.querySelector('h6') || el) : el;
    mark.classList.remove('sh-target');
    void mark.offsetWidth; // restart the animation when the same target is jumped to twice
    mark.classList.add('sh-target');
}

// The editor console's keys, anywhere outside a field: '/' puts the cursor in its search, N starts
// a new article, D toggles the data view, M opens the magazines, Esc closes what is open. Inside a
// field (or the rich text editor) keys are left alone: they are being typed.
var _consoleComponent = null;

function registerConsoleKeys(component) {
    _consoleComponent = component;
    if (window._consoleKeys) return;
    window._consoleKeys = true;

    const shortcuts = {n: 'new', d: 'data', m: 'magazines', Escape: 'escape'};

    window.addEventListener('keydown', e => {
        if (e.ctrlKey || e.metaKey || e.altKey) return;

        let el = document.activeElement;
        if (el && (el.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName))) return;
        if (document.querySelector('.modal.show')) return; // a dialog has the keys

        if (e.key === '/') {
            let input = document.getElementById('ed-cmd');
            if (!input) return;
            e.preventDefault();
            input.focus();
            return;
        }

        let action = shortcuts[e.key] || shortcuts[e.key.toLowerCase()];
        if (!action || !_consoleComponent) return;

        e.preventDefault();
        _consoleComponent.invokeMethodAsync('Shortcut', action).catch(() => { _consoleComponent = null; });
    });
}

function blurConsole() {
    let input = document.getElementById('ed-cmd');
    if (input) input.blur();
}

// Where the editor console is docked, kept per browser. Storage may be blocked (private mode);
// the console then stays at the bottom.
function consoleDock(top) {
    if (top === undefined) {
        try { top = localStorage.getItem('ed-dock') === 'top'; } catch (e) { top = false; }
    } else {
        try { localStorage.setItem('ed-dock', top ? 'top' : 'bottom'); } catch (e) { /* ignore */ }
    }

    document.body.classList.toggle('ed-top', top);
    return top;
}

// An answer of a question was dragged by its grip: Firefox only starts a drag with data attached, and
// the whole row, not just the grip, is what should follow the pointer.
document.addEventListener('dragstart', (evt) => {
    const grip = evt.target.closest && evt.target.closest('.ed-answer__grip');
    if (!grip || !evt.dataTransfer) return;
    evt.dataTransfer.effectAllowed = 'move';
    try { evt.dataTransfer.setData('text/plain', ''); } catch (e) { /* ignore */ }
    const row = grip.closest('.ed-answer');
    if (row) evt.dataTransfer.setDragImage(row, grip.offsetLeft + 8, row.offsetHeight / 2);
});

// After an answer moved by Alt+arrow: if the browser dropped the focus while moving the row, put it
// on the row's toggle again so the next Alt+arrow keeps moving the same answer.
function focusAnswer(index) {
    const active = document.activeElement;
    const slot = document.querySelectorAll('.ed-answers > .ed-answer-slot')[index];
    if (!slot || (active && active !== document.body && slot.contains(active))) return;
    slot.querySelector('.ed-answer__toggle')?.focus();
}

// Busy feedback. A click on the console or the spine waits for the server (the settings, the
// statistics, an article), which can take a moment. The clicked button pulses at once; if the wait
// lasts, a bar runs along the top of the window and of the console. Both stop once the page has
// changed and settled, and nothing on it says it is still loading.
(() => {
    const TARGETS = '.ed-dock button, main.ed-spine button';
    const SKIP    = '.jodit-container, .ed-answer__grip, [data-nobusy]'; // answered in the browser itself
    const LOADING = '.ed-stats__loading, .ed-skel-card, .ed-skel-row';

    let button = null, show = null, settle = null, idle = null, cap = null;

    function stop() {
        [show, settle, idle, cap].forEach(clearTimeout);
        document.body.classList.remove('ed-busy');
        if (button) delete button.dataset.busy;
        button = null;
    }

    function check() {
        if (document.querySelector(LOADING)) { settle = setTimeout(check, 250); return; }
        stop();
    }

    function start(el) {
        stop();
        button = el;
        el.dataset.busy = '';
        show = setTimeout(() => document.body.classList.add('ed-busy'), 150);
        idle = setTimeout(stop, 4000);  // nothing changed at all: nothing to wait for
        cap  = setTimeout(stop, 20000);
    }

    document.addEventListener('click', (evt) => {
        const el = evt.target.closest && evt.target.closest(TARGETS);
        if (el && !el.closest(SKIP) && !el.disabled) start(el);
    }, true);

    // Enter in the console's search runs the chosen result
    document.addEventListener('keydown', (evt) => {
        if (evt.key === 'Enter' && evt.target.id === 'ed-cmd' && evt.target.value) start(evt.target);
    }, true);

    new MutationObserver((records) => {
        if (!button) return;
        if (records.every(r => r.target === button || r.target === document.body)) return; // our own marks
        clearTimeout(idle);
        clearTimeout(settle);
        settle = setTimeout(check, 250);
    }).observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });
})();
